<template lang="html">
  <div id="login-page" class="contained-height">
    <div class="form" @keyup.enter="login()">
      <div class="form-field mb-4" style="visibility: hidden;">
        <div>email</div>
        <input v-model="email" id="login-page-email" type="text" placeholder="example@email.com"
        @click="clearStatus()">
      </div>
      <div class="form-field mb-4">
        <div>password</div>
        <input v-model="password" type="password"
        @click="clearStatus()">
      </div>
      <button @click="login()" class="btn btn-action">login</button>
      <div class="status mt-4"
      :class="{ 'error': status === 'error' }">{{ statusText }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import AuthService from '@/services/auth';

export default {
  name: 'login-page',
  data() {
    return {
      email: 'leon@adhocstudio.ca',
      password: '',
      status: '',
      statusText: ''
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn'
    })
  },
  methods: {
    ...mapMutations({
      setPageReady: 'ui/setPageReady'
    }),
    ...mapActions({
      authenticate: 'user/authenticate',
      resetFloorplans: 'floorplans/reset'
    }),
    async login() {
      this.statusText = 'Checking credentials...';
      this.status = '';
      const credentials = {
        email: this.email,
        password: this.password
      };
      const status =
        await AuthService.authenticate(credentials);
      if (status === 'ok') {
        this.setPageReady(false);
        this.$router.push('/');
      } else {
        this.statusText = status;
        this.status = 'error';
      }
    },
    clearStatus() {
      this.status = '';
    }
  },
  mounted() {
    this.setPageReady(true);
    if (!this.isLoggedIn) {
      this.resetFloorplans();
    }
    document.getElementById('login-page-email').focus();
  },
  beforeDestroy() {
    this.setPageReady(false);
  }
};
</script>

<style lang="scss" scoped>
#login-page {
  background-color: var(--action);
}

.form {
  width: 200px;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.form-field {
  text-align: left;
  width: 100%;

  input {
    color: white;
    background: transparent;
    border: none;
    border-bottom: 1px solid var(--text);
    width: 100%;
    outline: 0;
  }
}

.btn {
  &:hover {
    text-decoration: underline;
  }
}

.status {
  height: 50px;
  line-height: 1rem;
}

.error {
  color: hsl(0, 50%, 60%);
}
</style>



// WEBPACK FOOTER //
// src/pages/LoginPage/LoginPage.vue